module.exports={
  "Description": "SO : AA NNNNN",
  "RedundantCharacters": " -",
  "ValidationRegex": "^[a-zA-Z]{2}[0-9]{5}$",
  "TestData": {
    "Valid": [
      "AW12345",
      "BN47899"
    ],
    "Invalid": [
      "12345",
      "A12345",
	  "SL123456"
    ]
  }
}